import gql from 'graphql-tag';

export const insertCourseMutation = gql`
  mutation InsertCourse($object: courses_insert_input!) {
    insert_courses_one(object: $object) {
      id
    }
  }
`;

export const updateCourseMutation = gql`
  mutation UpdateCourse($id: uuid!, $changes: courses_set_input!) {
    update_courses_by_pk(pk_columns: { id: $id }, _set: $changes) {
      id
    }
  }
`;

export const getCourseType = gql`
  query getCourseType($limit: Int, $offset: Int, $search: String) {
    course_type(limit: $limit, offset: $offset, where: { 
      name: { _ilike: $search } 
    }) {
      id
      name
    }
  }
`;

export const getCompanyName = gql`
 query getCompanyName($limit: Int!, $offset: Int!, $search: String) {
  courses(
    distinct_on: company_name
    order_by: { company_name: asc }
    where: { 
      company_name: { _is_null: false }
      _and: [
        { company_name: { _ilike: $search } }
      ]
    }
    limit: $limit
    offset: $offset
  ) {
    company_name
  }
}
`;



export const getCourseCategory = gql`
  query getCourseCategory {
    course_categories (order_by : {name: asc}) {
      id
      name
    }
  }
`;


export const listAllCourses = gql`
  query ShowCourses($where: courses_bool_exp, $limit: Int, $offset: Int) {
    courses(where: $where, limit: $limit, offset: $offset, order_by: { created_at: desc }) {
    id
    created_at
		course_name
    type  
		startDate
		endDate
    startTime
    endTime
		presented_by_image
		presented_by_name
		description
		company_name
		status
		active_status
    created_by_id
    course_registered_users_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;


export const getAllCourses = gql`
  query getAllCourses($where: courses_bool_exp, $limit: Int, $offset: Int) {
    courses(where: $where, limit: $limit, offset: $offset, order_by: { created_at: desc }) {
      id
    	created_at
		updated_at
		course_name
		course_category_id
		contact_name
        type
		startDate
		endDate
    startTime
    endTime
		presented_by_image
		presented_by_name
		description
		address
	    cpd_points
		number_of_seats
		early_bird_end_date
		early_bird_price
		afterwards_price
		topics_included
		learning_objectives
		event_type
		course_event_info
		sponsor_by_image
    course_banner_video
    course_banner_image
    course_gallery
		terms
		refund_policy
		company_name
		contact_email
		contact_phone
		contact_website
		status
		active_status
    register_link
    
    }
  }
`;

export const getCoursesCountByStatus = gql`
  query getCoursesCountByStatus(
  $whereAll: courses_bool_exp = {}
  $whereDraft: courses_bool_exp = {}
  $where: courses_bool_exp = {}
) {
  all: courses_aggregate(where: $whereAll) {
    aggregate {
      count
    }
  }
  draft: courses_aggregate(where: $whereDraft) {
    aggregate {
      count
    }
  }
  pending: courses_aggregate(
    where: { _and: [$where, { status: { _eq: "PENDING" } }] }
  ) {
    aggregate {
      count
    }
  }
  active: courses_aggregate(
    where: {
      _and: [
        $where
        { status: { _eq: "APPROVE" }, active_status: { _eq: "ACTIVE" } }
      ]
    }
  ) {
    aggregate {
      count
    }
  }
  inactive: courses_aggregate(
    where: {
      _and: [
        $where
        { status: { _eq: "APPROVE" }, active_status: { _eq: "INACTIVE" } }
      ]
    }
  ) {
    aggregate {
      count
    }
  }
  expired: courses_aggregate(
    where: { _and: [$where, { status: { _eq: "EXPIRED" } }] }
  ) {
    aggregate {
      count
    }
  }
  approve: courses_aggregate(
    where: { _and: [$where, { status: { _eq: "APPROVE" } }] }
  ) {
    aggregate {
      count
    }
  }
  rejected: courses_aggregate(
    where: { _and: [$where, { status: { _eq: "REJECT" } }] }
  ) {
    aggregate {
      count
    }
  }
}

`;
export const GetCourseById = gql`
  query GetCourseById($id: uuid!) {
    courses_by_pk(id: $id) {
      	id
    	created_at
		updated_at
		course_name
		course_category_id
		contact_name
        type
		startDate
		endDate
    startTime
    endTime
		presented_by_image
		presented_by_name
		description
		address
	    cpd_points
		number_of_seats
		early_bird_end_date
		early_bird_price
		afterwards_price
		topics_included
		learning_objectives
		event_type
		course_event_info
		sponsor_by_image
    course_banner_video
    course_banner_image
    course_gallery
		terms
		refund_policy
		company_name
		contact_email
		contact_phone
		contact_website
		status
		active_status
    register_link
    rsvp_date
    webinar_link  
    }
  }
`;


export const deleteCourseFromListMutation = gql`
  mutation DeleteCourse($id: uuid!) {
    delete_courses_by_pk(id: $id) {
      id
    }
  }
`;


export const updateCourseStatusMutation = gql`
  mutation UpdateCourseStatus($id: uuid!, $status: String!) {
    update_courses_by_pk(pk_columns: { id: $id }, _set: { active_status: $status }) {
      id
      active_status
    }
  }
`;

// course.mutations.ts
export const updateCourseApproveStatusMutation = gql`
  mutation UpdateCourseStatus($id: uuid!, $status: String!) {
    update_courses_by_pk(pk_columns: { id: $id }, _set: { status: $status }) {
      id
      status
    }
  }
`;


//
export const registerUserMutation = gql`
  mutation RegisterUser($object: course_registered_users_insert_input!) {
    insert_course_registered_users_one(object: $object) {
      id
      first_name
      last_name
      email
      phone_number
      description
      course_id
      from_id
      created_at
    }
  }
`;



export const getRegCourseById = gql`
  query GetCourseById($id: uuid!) {
    courses_by_pk(id: $id) {
    id
    created_at
		updated_at
		course_name
		contact_name
    type
		startDate
		endDate
    startTime
    endTime
		presented_by_image
		presented_by_name
		description
		number_of_seats
		event_type
		company_name
		contact_email
		contact_phone
		contact_website
		status
		active_status
    }
  }
`;

export const getCourseRegisteredUsers = gql`
  query getCourseRegisteredUsers($course_id: uuid!, $limit: Int!, $offset: Int!) {
    course_registered_users(
      where: { course_id: { _eq: $course_id } }
      limit: $limit
      offset: $offset
      order_by: { created_at: desc }
    ) {
      id
      first_name
      last_name
      email
      phone_number
      description
      course_id
      from_id
      created_at
      directories_practice{
      id
      dental_practice{
      id
      logo
      }
      }
      directories_supplier{
      id
      dental_supplier{
      id
      logo
      }
      }
      directories_professional{
      id
      dental_professional{
      id
      profile_image
      }
      }
    }
  }
`;

////


export const getRegisteredCoursesByUser = gql`
  query GetUserRegisteredCourses(
    $where: courses_bool_exp!, 
    $limit: Int!, 
    $offset: Int!
  ) {
    courses(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { startDate: desc }
    ) {
      id
      type
      endDate
      startDate
      startTime
    endTime
      course_name
      description
      created_at
      cpd_points
      presented_by_name
      presented_by_image
      company_name
      webinar_link
      course_category_id
      course_category{
      id
      name

      }
    }
  }
`;


// Insert course mutation
export const INSERT_COURSE = gql`
  mutation InsertCourse($object: courses_insert_input!) {
    insert_courses_one(object: $object) {
      id
    }
  }
`;

// Update course mutation
export const UPDATE_COURSE = gql`
  mutation UpdateCourse($id: uuid!, $object: courses_set_input!) {
    update_courses_by_pk(pk_columns: { id: $id }, _set: $object) {
      id
    }
  }
`;

// Insert newsfeed mutation
export const INSERT_NEWSFEED = gql`
  mutation InsertNewsfeed($object: newsfeeds_insert_input!) {
    insert_newsfeeds_one(object: $object) {
      id
    }
  }
`;


